import ActionTypes from "../actions/actionTypes";

const initialState = {
  organizationRoles: [],
  loading: false,
  error: null,
};

const organizationRolesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_ORGANIZATION_ROLES:
      return {
        ...state,
        organizationRoles: action.payload,
        error: null,
      };

    case ActionTypes.SET_ORGANIZATION_ROLES_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case ActionTypes.SET_ORGANIZATION_ROLES_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case ActionTypes.CLEAR_ORGANIZATION_ROLES:
      return {
        ...state,
        organizationRoles: [],
        error: null,
        loading: false,
      };

    case ActionTypes.LOGOUT_USER:
      // Reset organization roles state on logout
      return initialState;

    default:
      return state;
  }
};

export default organizationRolesReducer;
